import { createContext, useContext, useState, ReactNode } from 'react';

interface TrinityBondContextType {
  selectedBondAddress: `0x${string}` | null;
  setSelectedBondAddress: (address: `0x${string}` | null) => void;
}

const TrinityBondContext = createContext<TrinityBondContextType | undefined>(undefined);

export function TrinityBondProvider({ children }: { children: ReactNode }) {
  const [selectedBondAddress, setSelectedBondAddress] = useState<`0x${string}` | null>(null);

  return (
    <TrinityBondContext.Provider value={{ selectedBondAddress, setSelectedBondAddress }}>
      {children}
    </TrinityBondContext.Provider>
  );
}

export function useTrinityBond() {
  const context = useContext(TrinityBondContext);
  if (context === undefined) {
    throw new Error('useTrinityBond must be used within a TrinityBondProvider');
  }
  return context;
} 